export default function remove(el) {
  el.parentNode && el.parentNode.removeChild(el);
}